import * as storage from '../../../core/store/root/storage';
import { ILocalidad } from '../../models/ILocalidad';
export const LocalidadFeatureKey = 'localidades';
export interface ILocalidadState {
   localidades: ILocalidad[];
}

export const initialLocalidadState: ILocalidadState = {
  localidades: storage.getItem('localidades').localidades,
};
